import React from 'react';
import { findByText } from 'Common/Utils';
import { HookShotChaperone, ClickGesture } from 'Snippets/Redundancy';
import { IntroNotice } from './IntroNotice';

export const ControllableFields = [
	{
		message: <IntroNotice message={2} />,
		find: 'a[data-chaperone-trigger]',
	},
	{
		message: (
			<>
				To implement controllable form fields, you must put the field state property{' '}
				<b>value</b> in the form field attribute <b>value</b>...
			</>
		),
		find(target) {
			return findByText(target, 'span:email')[4];
		},
	},
	{
		message: (
			<>
				But firstly, I wanna stressed on how you can set a default value in the
				circulation of the controllable fields...
			</>
		),
		find(target) {
			return findByText(target, 'span:usernameDefault')[0];
		},
	},
	{
		message: (
			<>
				You can set a <b>value</b> in the schema to set a default
				value. but remember once you <b>submit</b> a form and <b>reset</b> it.
				it will neglect the schema after, because that is how <b>react</b> <b>useState</b>
				{' '}works. but if you want to update constantly the schema or the default value
				like when you update some data, you can <b>unmount</b> the component(which you put the 
				{' '}<b>useForm</b>) after submit then <b>mount</b> it again when you are about to update data...
			</>
		),
		find(target) {
			return findByText(target, 'span:value')[0];
		},
		...HookShotChaperone({
			target(target) {
				return findByText(target, 'span:value')[0];
			},
			from(target) {
				return findByText(target, 'span:usernameDefault')[1];
			},
			to(target) {
				return findByText(target, 'span:usernameDefault')[0];
			},
		}),
	}, 
	{
		message: (
			<>
				<div style={{ textAlign: 'center', padding: '20px 5px' }}>
					<img
						src='/images/icons/icon-72x72.png'
						alt='beard guy'
						width='60px'
						height='60px'
						style={{ display: 'inline-block', margin: '0 auto' }}
					/>
				</div>
				<div>That was quick! Let's try out the result!</div>
			</>
		),
		find: 'input',
		isDoneOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
		},
	},
];
